import $ from "jquery";
import { MRI_SPINE_VALIDATION_MSG } from "../../../constants/Constants";

export const validateMriFindings = () => {
	let clinicalProfile = $("#clinical-profile").val();
	let clinicalProfileCmt = $("#clinical-profile_comment").val();
	let impressionsSuggested = $("#impressions_suggested").val();
	let impressionsSuggestedCmt = $("#impressions_suggested_comment").val();
	if(clinicalProfile.includes('Other') && 
			(clinicalProfileCmt == null || clinicalProfileCmt == undefined 
					|| clinicalProfileCmt == "")){
		return {
            error: 1,
            message:MRI_SPINE_VALIDATION_MSG._iMessageOtherClinicalProfileError
        }
	}
	else if(impressionsSuggested.includes('Other') && 
			(impressionsSuggestedCmt == null || 
					impressionsSuggestedCmt == undefined || impressionsSuggestedCmt == "")){
		return {
            error: 1,
            message:MRI_SPINE_VALIDATION_MSG._iMessageOtherSuggestedImpressionError
        }
	}
	
    return null;
	
}